import { PipeTransform, Pipe } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'profileStatus',
    standalone: false
})
export class ProfileStatusPipe implements PipeTransform {
  transform(startDate: Date, endDate: Date): string {
    if (moment(new Date()).isBefore(moment(startDate).startOf('day'))) {
      return 'PROFILE_PLANNED';
    }
    if (moment(new Date()).isBetween(moment(startDate).startOf('day'), moment(endDate).endOf('day')) || (moment(new Date()).isAfter(moment(startDate)) && !endDate)) {
      return 'PROFILE_IN_PROGRESS';
    }
    if (moment(new Date()).isAfter(moment(endDate).endOf('day'))) {
      return 'PROFILE_EXPIRED';
    }
    return '';
  }
}
